import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { StoreState } from '../../store'
import { Back, Container, Content, Form, Title } from './styles'
import { useForm, SubmitHandler } from 'react-hook-form'
import { BsArrowLeftShort, BsEye, BsEyeSlash } from 'react-icons/bs'
import key from '../../assets/key-64.svg'
import { FiKey } from 'react-icons/fi'
import { toast } from 'react-hot-toast'
import * as yup from 'yup'
import api from '../../services/axios'
import { MdOutlinePassword } from 'react-icons/md'
import { RiLockPasswordLine } from 'react-icons/ri'
import { get } from 'lodash'
interface Inputs {
    password: string
    passwordConfirm: string
}

const schema = yup.object().shape({
    password: yup.string().required(),
    passwordConfirm: yup.string().required(),
})

const CriarNovaSenha: React.FC = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { isLoggedIn } = useSelector((state: StoreState) => state.auth)
    const {
        handleSubmit,
        register,
        formState: { errors },
        getValues,
    } = useForm<Inputs>()
    const [showPassword, setShowPassword] = useState(false)
    // useEffect(() => {
    //     if (isLoggedIn) navigate('/dashboard')
    // }, [navigate, isLoggedIn])

    // useEffect(() => {
    //     if (!searchParams.get('token') || !searchParams.get('id')) {
    //         navigate('/not-founddadada')
    //     }
    // }, [searchParams, navigate])

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        try {
            const isValid = await schema.isValid({
                password: inputs.password,
                passwordConfirm: inputs.passwordConfirm,
            })

            if (!isValid) {
                return toast.error('Não foi possível alterar a senha.')
            }

            if (inputs.password !== inputs.passwordConfirm) {
                return toast.error('As senhas são diferentes')
            }

            await api.post(
                `/new-password?id=${searchParams.get(
                    'id'
                )}&token=${searchParams.get('token')}`,
                {
                    password: inputs.password,
                    passwordConfirm: inputs.passwordConfirm,
                }
            )
            toast.success('Sua senha foi alterada')
            navigate('/login')
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')
            return toast.error(messageError)
        }
    }
    const baseStyleInputs =
        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
    return (
        <Container>
            <Content>
                <Title>
                    <div className="key">
                        <span className="background">
                            <span>
                                <RiLockPasswordLine size={28} color="#3BAE5B" />
                            </span>
                        </span>
                    </div>
                    <h1 className="text-3xl text-gray-900 mb-2">
                        Criar nova senha
                    </h1>
                    <h3 className="text-base text-gray-500">
                        Digite sua nova senha e repita isso. Lembre-se de
                        anotá-la.
                    </h3>
                </Title>
                <Form onSubmit={handleSubmit(submit)}>
                    <div className="field">
                        <div className="relative">
                            <label
                                htmlFor="password"
                                className="text-gray-700 text-sm label"
                            >
                                Digite sua nova senha
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                {...register('password', {
                                    required: 'O campo senha é obrigatório',
                                    minLength: 6,
                                    maxLength: 32,
                                })}
                                disabled={
                                    !searchParams.get('token') ||
                                    !searchParams.get('id')
                                }
                                className={
                                    errors.password &&
                                    (errors.password.type === 'required' ||
                                        errors.password.type === 'validate' ||
                                        errors.password.type === 'minLength' ||
                                        errors.password.type === 'maxLength')
                                        ? `${baseStyleInputs} ring-red-500 ring-2`
                                        : baseStyleInputs
                                }
                                placeholder="Sua nova senha"
                            />

                            {showPassword ? (
                                <button
                                    type="button"
                                    className="absolute text-gray-500 right-2 bottom-3"
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                >
                                    <BsEyeSlash size={20} />
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="absolute text-gray-500 right-2 bottom-3"
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                >
                                    <BsEye size={20} />
                                </button>
                            )}
                        </div>
                        {errors.password && (
                            <span className="text-base text-red-500 mt-1 block">
                                {errors.password.message ||
                                    'A senha deve ter entre 6 e 32 caracteres.'}
                            </span>
                        )}
                    </div>
                    <div className="field">
                        <div className="relative">
                            <label
                                htmlFor="passwordConfirm"
                                className="text-gray-700 text-sm label"
                            >
                                Confirme sua senha
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="passwordConfirm"
                                {...register('passwordConfirm', {
                                    required:
                                        'O campo confirme sua senha é obrigatório',
                                    minLength: 3,
                                    maxLength: 255,
                                    validate: {
                                        matchesPreviousPassword: (value) => {
                                            const { password } = getValues()
                                            return (
                                                password === value ||
                                                'As senhas precisam ser iguais'
                                            )
                                        },
                                    },
                                })}
                                disabled={
                                    !searchParams.get('token') ||
                                    !searchParams.get('id')
                                }
                                className={
                                    errors.passwordConfirm &&
                                    (errors.passwordConfirm.type ===
                                        'required' ||
                                        errors.passwordConfirm.type ===
                                            'validate' ||
                                        errors.passwordConfirm.type ===
                                            'minLength' ||
                                        errors.passwordConfirm.type ===
                                            'maxLength')
                                        ? `${baseStyleInputs} ring-red-500 ring-2`
                                        : baseStyleInputs
                                }
                                placeholder="Confirme sua senha"
                            />
                            {showPassword ? (
                                <button
                                    type="button"
                                    className="absolute text-gray-500 right-2 bottom-3"
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                >
                                    <BsEyeSlash size={20} />
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="absolute text-gray-500 right-2 bottom-3"
                                    onClick={() =>
                                        setShowPassword(!showPassword)
                                    }
                                >
                                    <BsEye size={20} />
                                </button>
                            )}
                        </div>
                        {errors.passwordConfirm && (
                            <span className="text-base text-red-500 mt-1 block">
                                {errors.passwordConfirm.message ||
                                    'A senha deve ter entre 6 e 32 caracteres.'}
                            </span>
                        )}
                    </div>
                    <div className="actions">
                        <button
                            type="submit"
                            disabled={
                                !searchParams.get('token') ||
                                !searchParams.get('id')
                            }
                            className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
                        >
                            Alterar senha
                        </button>
                    </div>
                </Form>
                <Back>
                    <Link to="/login" className="text-base text-gray-700">
                        <BsArrowLeftShort size={22} />
                        Voltar para login
                    </Link>
                </Back>
            </Content>
        </Container>
    )
}

export default CriarNovaSenha
